import { Injectable, inject, NgZone } from '@angular/core';
import { AuthService } from './../auth/auth.service';
import Shepherd from 'shepherd.js';

@Injectable({
  providedIn: 'root',
})
export class IdleService {
  private timeout: any;
  private idleTime = 3 * 60 * 1000;
  private authService = inject(AuthService);
  private ngZone = inject(NgZone);

  constructor() {
    this.startIdleMonitor();
  }

  private startIdleMonitor() {
    this.resetTimer();
    this.addEventListeners();
  }

  private addEventListeners() {
    document.addEventListener('mousemove', () => this.resetTimer());
    document.addEventListener('keydown', () => this.resetTimer());
    document.addEventListener('click', () => this.resetTimer());
    document.addEventListener('scroll', () => this.resetTimer());
  }

  private resetTimer() {
    clearTimeout(this.timeout);
    this.ngZone.runOutsideAngular(() => {
      this.timeout = setTimeout(() => this.logoutUser(), this.idleTime);
    });
  }

  private logoutUser() {
    this.ngZone.run(() => {
      console.warn('Inactive user. Signing out...');
      if (Shepherd.activeTour) Shepherd.activeTour.complete();
      this.authService.logout();
    });
  }
}
